@if (results && results.length) {
  <div>
    <app-sorting-toggle
      (sortingSelected)="onSortingSelected($event)"
      [sortingTypes]="searchParams.sortDropdownValues"
    >
    </app-sorting-toggle>
    @for (item of results; track item) {
      <div class="flex-row-container--tb-margin">
        <div class="irl-list_item half-container">
          <div class="half-block flex-row-container">
            @if (getOperator(item) !== 'EUR') {
              <img
                src="https://images.sabscorp.com/images/enterprise/lightUK/assets/images/{{
                  getOperator(item)
                }}.png"
                class="irl-list_item-logo"
                alt="{{ getOperator(item) }} Logo"
              />
            }
            @if (getOperator(item) === 'EUR') {
              <img
                title=""
                style="min-width: 45px"
                src="./assets/svg/eurostar.svg"
                alt="eurostar"
                class="irl-list_item-logo"
              />
            }
            <div class="irl-list_schedule flex-row-container">
              <div class="flex-column-container">
                <div class="irl-list_schedule">
                  <span i18n="@@railDepart">Depart</span>: {{ item.from }}
                </div>
                <div class="irl-list_schedule">
                  <span i18n="@@railArrive">Arrive</span>:{{ item.to }}
                </div>
              </div>
              <div class="flex-column-container">
                <div class="irl-list_schedule">
                  {{ item.departDateTime | sabsTimePipe: 'timeString' }}
                </div>
                <div class="irl-list_schedule">
                  {{ item.arriveDateTime | sabsTimePipe: 'timeString' }}
                </div>
              </div>
              <div class="flex-column-container">
                <div class="irl-list_schedule">{{ isDirect(item) | translate }}</div>
                <div class="irl-list_schedule">
                  Duration: {{ calculateDuration(item) | sabsTimePipe: 'min_duration' }}
                </div>
              </div>
              <!-- <div class="irl-list_legs">
            <span class="irl-list_leg"
            i18n="@@irlListDirect">{{'Direct' | translate}}</span>
          </div> -->
            </div>
          </div>
          <div class="half-block flex-row-container">
            @if (
              getCheapestClassTicket(item, ClassType.Class_2, ClassType.Second_Class) || [];
              as cheapestSecond
            ) {
              <button
                (click)="toggleFare(cheapestSecond)"
                [disabled]="disabledCheck()"
                aria-labelledby=""
                class="irl-list_item-fare"
              >
                <span>
                  <span class="sr-only" i18n="@@irl2ndclassCheapest">2nd Class </span>
                  @if (!cheapestSecond.selected) {
                    <div>
                      @if (cheapestSecond.price) {
                        <span class="price-container">
                          <span
                            ><span i18n="@@itineraryFromCheapest">From:</span>
                            {{ cheapestSecond.price | currency: cheapestSecond.currency }}</span
                          >
                          @if (searchParams.discountCard[0]?.name) {
                            <section (mouseleave)="ttPercentage.close()">
                              <span
                                class="percentage-icon"
                                i18n-ngbTooltip
                                placement="top"
                                tooltipClass="custom-tooltip"
                                tabindex="0"
                                triggers="manual"
                                #ttPercentage="ngbTooltip"
                                (mouseenter)="ttPercentage.open()"
                                (focus)="ttPercentage.open()"
                                (blur)="ttPercentage.close()"
                                [ngbTooltip]="searchParams.discountCard[0]?.name"
                                >%</span
                              >
                            </section>
                          }
                        </span>
                      }
                    </div>
                  }
                  <div>
                    @if (cheapestSecond?.fareInfo?.code) {
                      <section class="container" (mouseleave)="tt1.close()">
                        <i
                          class="ico-star"
                          ngbTooltip="Company Negotiated Rate"
                          i18n-ngbTooltip
                          triggers="manual"
                          #tt1="ngbTooltip"
                          (mouseenter)="tt1.open()"
                          (focus)="tt1.open()"
                          (blur)="tt1.close()"
                          tabindex="0"
                        >
                        </i>
                      </section>
                    }
                  </div>
                  @if (cheapestSecond.selected) {
                    <div>
                      <span i18n="@@Deselect">Deselect</span>
                    </div>
                  }
                </span>
              </button>
            }
            @if (
              getCheapestClassTicket(item, ClassType.Class_1, ClassType.First_Class) || [];
              as cheapestFirst
            ) {
              <button
                [disabled]="disabledCheck()"
                (click)="toggleFare(cheapestFirst)"
                class="irl-list_item-fare"
              >
                @if (cheapestFirst.price) {
                  <span>
                    @if (!cheapestFirst.selected) {
                      <div>
                        <span class="sr-only" i18n="@@irl1stclass">1st Class </span>
                        <span class="price-container">
                          <span
                            ><span i18n="@@itineraryFromCheapest">From:</span>
                            {{
                              cheapestFirst.selected
                                ? 'Selected'
                                : (cheapestFirst.price | currency: cheapestFirst.currency)
                            }}</span
                          >
                          @if (searchParams.discountCard[0]?.name) {
                            <section class="container" (mouseleave)="ttPercentage2.close()">
                              <span
                                class="percentage-icon"
                                tooltipClass="custom-tooltip"
                                i18n-ngbTooltip
                                [ngbTooltip]="searchParams.discountCard[0]?.name"
                                tabindex="0"
                                triggers="manual"
                                #ttPercentage2="ngbTooltip"
                                (mouseenter)="ttPercentage2.open()"
                                (focus)="ttPercentage2.open()"
                                (blur)="ttPercentage2.close()"
                                >%</span
                              >
                            </section>
                          }
                        </span>
                      </div>
                    }
                    <div>
                      @if (cheapestFirst.fareInfo.code) {
                        <section (mouseleave)="tt2.close()" class="container">
                          <i
                            class="ico-star"
                            ngbTooltip="Company Negotiated Rate"
                            i18n-ngbTooltip
                            triggers="manual"
                            #tt2="ngbTooltip"
                            (mouseenter)="tt2.open()"
                            (focus)="tt2.open()"
                            (blur)="tt2.close()"
                            tabindex="0"
                          >
                          </i>
                        </section>
                      }
                    </div>
                    @if (cheapestFirst.selected) {
                      <div>
                        <span i18n="@@Deselect">Deselect</span>
                      </div>
                    }
                  </span>
                }
              </button>
            }
          </div>
        </div>
        <div class="irl_detail_container">
          <div class="irl_detail_title">
            <b
              ><span i18n="@@IrlListSearchTrainNumber">&nbsp;&nbsp;Train number</span>
              {{ item.identifiers.journeyIdentifier }}</b
            >
            • &nbsp;&nbsp;
            <b
              >&nbsp;&nbsp;<span i18n="@@flightLegsOperatedBy">Operated By</span>
              {{ item.segments[0].operator ? item.segments[0].operator : 'not provided' }}</b
            >
            • &nbsp;&nbsp; &nbsp;&nbsp;
          </div>
          <div class="irl_detail_info" (click)="item.ShowDetail = !item.ShowDetail" role="button">
            <b
              [attr.aria-expanded]="item.ShowDetail"
              attr.aria-controls="irl-detail-expended-{{ item.OutBoundUid }}"
              tabindex="0"
              (keydown.enter)="item.ShowDetail = !item.ShowDetail"
              class="detail-accordion"
              >{{ (item?.ShowDetail ? 'Collapse' : 'Show trip details & fares') | translate }}</b
            >
          </div>
        </div>
        @if (item.ShowDetail) {
          <div
            class="irl_detail_showdetail"
            id="irl-detail-expended-{{ item.identifiers.journeyIdentifier }}"
          >
            <app-irl-item-detail
              [item]="item"
              (selectIrl)="toggleFare($event)"
              [first]="getClassTickets(item, ClassType.Class_1, ClassType.First_Class)"
              [second]="getClassTickets(item, ClassType.Class_2, ClassType.Second_Class)"
              [legs]="item.segments"
              [currency]="item.providers[0].ticketOptions[0].currency"
              [trainNumber]="item.identifiers.journeyIdentifier"
              [isReturnTrip]="resType === 'inbound'"
              [discountCard]="searchParams.discountCard[0]?.name"
            >
            </app-irl-item-detail>
          </div>
        }
      </div>
    }
  </div>
}
@if (!results?.length) {
  <div>
    <div class="no_results_message background-container-background no_results_irl">
      <p>
        <strong i18n="@@irlResultsNoMatch"
          >This specific itinerary searched requires an offline booking, please use the link below
          to submit your offline request</strong
        >
      </p>
    </div>
    <div class="no_results_message no_results_irl">
      <p class="no_results_link">
        <a (click)="goOfflineForm()" i18n="@@irlResultsContact"
          >Click here to contact the offline request form. When you submit the request a member of
          the
          @if (!isScion) {
            CTM
          }
          team will be in touch with a quote.</a
        >
      </p>
    </div>
  </div>
}
